var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c(
            "textarea-field",
            {
              attrs: {
                placeholder: "Escriba una observación",
                id: "observaciones"
              },
              model: {
                value: _vm.modelValue.observacion_dominical,
                callback: function($$v) {
                  _vm.$set(_vm.modelValue, "observacion_dominical", $$v)
                },
                expression: "modelValue.observacion_dominical"
              }
            },
            [
              _c("span", [_vm._v("Observaciones")]),
              _vm._v(" "),
              _vm.errores.observacion_dominical
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.observacion_dominical[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("VueCtkDateTimePicker", {
                attrs: {
                  id: "fecha_proximo_pago",
                  locale: "es",
                  "no-label": "",
                  "only-date": "",
                  "button-now-translation": "Ahora",
                  format: "YYYY-MM-DD",
                  formatted: "YYYY-MM-DD",
                  label: "Seleccione una fecha...",
                  noClearButton: "",
                  "disabled-weekly": [0]
                },
                model: {
                  value: _vm.modelValue.fecha_proximo_pago,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "fecha_proximo_pago", $$v)
                  },
                  expression: "modelValue.fecha_proximo_pago"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Generar recibo pago adelantado")])
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c("button", { staticClass: "btn-success", on: { click: _vm.guardar } }, [
        _c("i", { staticClass: "fa fa-save" }),
        _c("span", [_vm._v("Guardar")])
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("\n\t\t\t\tPago dominical\n\t\t\t")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e7e281c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e7e281c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/cobros/ObservacionDominical.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6e7e281c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/cobros/ObservacionDominical.vue
// module chunks = 0